let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9BxhS")).then(() => parcelRequire('5JXtG'));